import { render } from "./PointHistory.vue?vue&type=template&id=39d627d9&scoped=true"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"

import "./PointHistory.vue?vue&type=style&index=0&id=39d627d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d627d9"]])

export default __exports__